
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/claims/status",
      function () {
        return require("private-next-pages/claims/status/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/claims/status"])
      });
    }
  